import { ConfirmationDialogStyled } from './ConfirmationDialog'
import { PrimaryBtnBlue, PrimaryBtnOutline } from '../Buttons'
import { useTranslation } from 'react-i18next'

interface StartSharingModalProps {
    onConfirm: () => void;
    onCancel: () => void;
}

const StartSharingModal = ({ onConfirm, onCancel }: StartSharingModalProps) => {
    const { t } = useTranslation('meeting')

    return (
        <ConfirmationDialogStyled>
            <div className="info">
                <h2>{t('startSharingModal.title', 'Start Sharing Content?')}</h2>
                <div>
                    <p>{t('startSharingModal.confirmStart', 'Are you ready to start sharing content with other participants?')}</p>
                </div>
            </div>
            <div className="actions">
                <PrimaryBtnBlue onClick={onConfirm}>
                    {t('startSharingModal.startButton', 'Start Sharing')}
                </PrimaryBtnBlue>
                <PrimaryBtnOutline onClick={onCancel} colorTheme={'light'}>
                    {t('startSharingModal.cancelButton', 'Cancel')}
                </PrimaryBtnOutline>
            </div>
        </ConfirmationDialogStyled>
    )
}

export default StartSharingModal 